import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

const unwrap = (response) => {
    const body = response?.data;
    if (body?.status !== 1 && body?.status !== true && body?.allowed === false) throw new Error(body?.error?.message || body?.error || 'SMS request failed.');
    return body?.result;
};

export const fetchSmsWorkspace = () => customAxios.get('/v3/sms', { meta: { skipLoader: true } }).then(unwrap);
export const createSmsChat = () => customAxios.post('/v3/sms/chats', {}, { meta: { skipLoader: true } }).then(unwrap);
export const fetchSmsChat = (id) => customAxios.get(`/v3/sms/chats/${encodeURIComponent(id)}`, { meta: { skipLoader: true } }).then(unwrap);
export const saveSmsChatHistory = (id, messages) => customAxios.put(`/v3/sms/chats/${encodeURIComponent(id)}/history`, { messages }, { meta: { skipLoader: true } }).then(unwrap);
export const askSmsQuestion = (question, history = []) => customAxios.post('/v3/sms/chat', { question, history }, { meta: { skipLoader: true } }).then(unwrap);
export const streamSmsQuestion = async (question, history = [], onDelta, signal) => {
    const authHeader = getAuthHeader();
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/v3/sms/chat/stream`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(authHeader?.headers || {}) },
        body: JSON.stringify({ question, history }),
        signal,
    });
    if (!response.ok) {
        let body;
        try { body = await response.json(); } catch (error) { body = null; }
        throw new Error(body?.error?.message || body?.error || 'Unable to answer from the SMS.');
    }
    if (!response.body) throw new Error('Streaming is not available in this browser.');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let result = null;
    const processLine = (line) => {
        if (!line.startsWith('data:')) return;
        let event;
        try { event = JSON.parse(line.slice(5).trim()); } catch (error) { return; }
        if (event.type === 'delta' && event.text) onDelta(event.text);
        if (event.type === 'complete') result = event.result;
        if (event.type === 'error') throw new Error(event.message || 'Unable to answer from the SMS.');
    };
    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split(/\r?\n/);
        buffer = lines.pop() || '';
        lines.forEach(processLine);
    }
    buffer += decoder.decode();
    if (buffer) processLine(buffer);
    if (!result) throw new Error('The SMS answer stream ended unexpectedly.');
    return result;
};
export const saveSmsSettings = (additionalInformation) => customAxios.put('/v3/sms/settings', { additionalInformation }, { meta: { skipLoader: true } }).then(unwrap);
export const deleteSmsDocument = (id) => customAxios.delete(`/v3/sms/document/${encodeURIComponent(id)}`, { meta: { skipLoader: true } }).then(unwrap);
export const uploadSmsDocument = ({ file, kind, name }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    formData.append('name', name || file.name.replace(/\.pdf$/i, ''));
    return customAxios.post('/v3/sms/document', formData, { meta: { skipLoader: true } }).then(unwrap);
};
export const fetchSmsPdf = (url) => customAxios.get(url, { responseType: 'blob', meta: { skipLoader: true } }).then((response) => response.data);
